import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import { BarChartDemo, LineChartDemo, PieChartDemo } from './ChartDemo'
import ChartElement from './ChartElement'
import ChartFormBrand from './ChartFormBrand'
import { STYLE_FORM_SCHEMA } from './ChartFormStyle'
import ChartFormValue from './ChartFormValue'
import ChartIcon from './assets/chart.svg'

export default genElementConfig(CONFIG_ELEMENTS.chart, {
  label: t('elements.chart.label'),
  icon: ChartIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: ChartElement,
  Demo: [LineChartDemo, BarChartDemo, PieChartDemo],
  FormValue: ChartFormValue,
  FormBrand: ChartFormBrand,
  EditorActions: null,
})
